import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import axiosInstance from '../../../services/axiosInstance';

const GoogleCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing');
    const [error, setError] = useState('');

    const processed = React.useRef(false);

    useEffect(() => {
        const code = searchParams.get('code');
        console.log("Create Callback - SearchParams:", searchParams.toString());

        if (code) {
            if (processed.current) return;
            processed.current = true;
            connectCalendar(code);
        } else {
            setStatus('error');
            setError('No authorization code found');
        }
    }, [searchParams]);

    const connectCalendar = async (code) => {
        try {
            const userId = localStorage.getItem("userId");

            if (!userId) {
                setStatus('error');
                setError('User not logged in. Please login first.');
                return;
            }

            await axiosInstance.post('/calendar/connect', {
                code,
                userId
            });
            setStatus('success');
            setTimeout(() => {
                navigate('/appointment-booking'); // Redirect back to tabs
            }, 2000);
        } catch (err) {
            console.error(err);
            setStatus('error');
            setError('Failed to connect Google Calendar. ' + (err.response?.data?.message || err.message));
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
            {status === 'processing' && (
                <>
                    <CircularProgress size={60} />
                    <Typography variant="h6" mt={2}>Connecting to Google Calendar...</Typography>
                </>
            )}

            {status === 'success' && (
                <Alert severity="success" sx={{ fontSize: '1.2rem', p: 3 }}>
                    Connected successfully! Redirecting...
                </Alert>
            )}

            {status === 'error' && (
                <Alert severity="error" sx={{ fontSize: '1.2rem', p: 3 }}>
                    {error}
                </Alert>
            )}
        </Box>
    );
};

export default GoogleCallback;
